<app-table
  [cols]="cols()"
  [actionButtons]="actionButtons"
  pageFunctionName="getPaginetedFilterList"
  [service]="categoryFilterService"
  modelName="filtros"
  sortField="description"
  [sortOrder]="-1"
  [defaultRows]="10"
  [addButton]="permission()"
  [dropdownFilters]="dropdownFilters"
  (booleanAction)="updateEnabled($event)"
  (actionButtonClick)="delete($event)"
/>
<p-confirmPopup />
<p-toast />
